const MARQUEE_ITEMS = [
  "Source-Backed Executive Intelligence",
  "Hallucination-Free CXO Decisions",
  "Enterprise Context Layer",
  "Persistent Strategic Memory",
  "99.9% Attribution Precision",
  "Designed for the Platforms You Already Run",
];

const EditorialMarquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

  return (
    <div
      className="relative overflow-hidden bg-[#0A0A0B]/80 border-y border-white/10 py-4"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {row.map((item, index) => (
          <span
            key={index}
            className="flex items-center font-mono text-xs uppercase tracking-[0.25em] text-white/35"
          >
            <span className="px-8">{item}</span>
            <span className="text-[#00E5FF]/50 text-[8px]">◆</span>
          </span>
        ))}
      </div>
      {/* Edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#050505] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#050505] to-transparent" />
    </div>
  );
};

export default EditorialMarquee;
